import { render, staticRenderFns } from "./OriginalProcess.vue?vue&type=template&id=68547946&scoped=true"
import script from "./OriginalProcess.vue?vue&type=script&lang=js"
export * from "./OriginalProcess.vue?vue&type=script&lang=js"
import style0 from "./OriginalProcess.vue?vue&type=style&index=0&id=68547946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68547946",
  null
  
)

export default component.exports